import { Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { formatShortDate } from "@/utils/formatDate.js";
import { whatsappLink } from "@/utils/whatsapp.js";

/**
 * Cuántas asesorías o consultas le quedan al usuario, y por dónde las pide.
 *
 * La tarjeta aparece sólo si le queda cupo: ligarla al cupo y no al paquete
 * hace que el 100 PRO herede el canal sin una regla escrita para él.
 *
 * El botón de WhatsApp no descuenta nada. Quien registra lo atendido es el
 * contador, al terminar: abrir una conversación no es haber atendido.
 */
const QuotaCard = ({ type, quota }) => {
  const { t } = useTranslation();
  const available = quota?.available ?? 0;
  const link = whatsappLink(t(`ui.quota.${type}Message`));

  // Mientras no haya datos tampoco hay tarjeta: más vale que aparezca tarde que
  // enseñarle a todo el mundo un recuadro que luego desaparece.
  if (available < 1) {
    return null;
  }

  return (
    <div className="col-xxl-4 col-md-6">
      <div className="card info-card">
        <div className="card-body">
          <h5 className="card-title">{t(`ui.quota.${type}Title`)}</h5>
          <div className="d-flex align-items-center">
            <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
              <i className="bi bi-chat-dots" />
            </div>
            <div className="ps-3 w-100">
              <h6 className="mb-1">
                {t("ui.quota.remaining", { count: available })}
              </h6>
              {quota?.expiresAt && (
                <p className="mb-2 text-muted small">
                  {t("ui.quota.expiresOn", {
                    date: formatShortDate(quota.expiresAt),
                  })}
                </p>
              )}
              {link ? (
                <a
                  className="btn btn-sm btn-success"
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-whatsapp me-1" />
                  {t("ui.quota.askByWhatsapp")}
                </a>
              ) : (
                <Badge bg="light" text="dark">
                  {t("ui.quota.channelPending")}
                </Badge>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotaCard;
